import * as yup from 'yup'
import {
  officeNameLengthMessage,
  phoneRequiredMessage,
  requiredMessage,
  jobTitleLengthMessage
} from '../../../strings/messages'

import { dont_know } from 'hotline_complaint_choices'
import {
  emailYup,
  firstNameYup,
  lastNameYup,
  middleNameYup,
  phoneYup
} from '../../../validators'
const dontKnow = Object.keys(dont_know).shift()

export const validationSchema = yup.object().shape({
  business_unit: yup
    .string()
    .when(
      ['hhs_program', 'office_of_secretary'],
      (hhs_program, office_of_secretary, schema) =>
        [hhs_program, office_of_secretary].includes(dontKnow) || hhs_program === 'FRAUD_GOV'
          ? schema
          : schema.required(requiredMessage)
    ),
  complaint_type: yup.string().required(requiredMessage),
  hhs_program: yup.string().required(requiredMessage),
  hhs_program_detail: yup.string().max(75, officeNameLengthMessage),
  office_of_secretary: yup.string().when('hhs_program', {
    is: 'OS',
    then: yup.string().required(requiredMessage),
    otherwise: yup.string()
  }),
  narrative: yup.string().required(requiredMessage),
  poc_reporting: yup.string().required(requiredMessage),
  first_name: firstNameYup(),
  middle_name: middleNameYup(false),
  last_name: lastNameYup(),
  employment__job_title: yup
    .string()
    .required(requiredMessage)
    .max(30, jobTitleLengthMessage),
  employment__email: emailYup(true),
  // require at least one of the phone numbers
  employment__phone: phoneYup(false).test(
    'phone_contact_required',
    phoneRequiredMessage,
    function(value) {
      return value || this.parent.employment__phone2
    }
  ),
  employment__phone2: phoneYup(false).test(
    'phone_contact_required',
    phoneRequiredMessage,
    function(value) {
      return value || this.parent.employment__phone
    }
  )
})
